import React, { useState } from "react";
import "../../App.css";
import "./Posters.css";
import { FaArrowAltCircleRight, FaArrowAltCircleLeft } from "react-icons/fa";
import { PostersData } from "./PostersData";

const Posters = (slides) => {
  const [current, setCurrent] = useState(0);
  const length = PostersData.length;

  const nextSlide = () => {
    setCurrent(current === length - 1 ? 0 : current + 1);
  };

  const prevSlide = () => {
    setCurrent(current === 0 ? length - 1 : current - 1);
  };

  // if (!Array.isArray(slides) || slides.length <= 0) {
  //   return null;
  // }
  // I have to figure this out later

  return (
    <section className="slider">
      <FaArrowAltCircleLeft className="left-arrow" onClick={prevSlide} />
      <FaArrowAltCircleRight className="right-arrow" onClick={nextSlide} />
      {PostersData.map((item, index) => {
        return (
          <div
            className={index === current ? "slide active" : "slide"}
            key={index}
          >
            {index === current && (
              <img src={item.image} alt="poster" className="image" />
            )}
          </div>
        );
      })}
    </section>
  );
};

export default Posters;
